import React, { useEffect, useState, useCallback } from "react";
import axiosInstance from "../../api/apiClient";

const partiesCacheByBranch = {};
const partiesPromiseByBranch = {};
const ownersCacheByBranch = {};
const ownersPromiseByBranch = {};

function fetchParties(branchId) {
  if (partiesCacheByBranch[branchId]) {
    return Promise.resolve(partiesCacheByBranch[branchId]);
  }
  if (!partiesPromiseByBranch[branchId]) {
    partiesPromiseByBranch[branchId] = axiosInstance
      .get("/ProjectParty", { params: { branchId } })
      .then((res) => {
        const data = Array.isArray(res.data?.data) ? res.data.data : [];
        partiesCacheByBranch[branchId] = data;
        return data;
      })
      .catch((err) => {
        partiesPromiseByBranch[branchId] = null; 
        throw err;
      });
  }
  return partiesPromiseByBranch[branchId];
}

function fetchOwners(branchId) {
  if (ownersCacheByBranch[branchId]) {
    return Promise.resolve(ownersCacheByBranch[branchId]);
  }
  if (!ownersPromiseByBranch[branchId]) {
    ownersPromiseByBranch[branchId] = axiosInstance
      .get("/ProjectOwner", { params: { branchId } })
      .then((res) => {
        const data = Array.isArray(res.data?.data) ? res.data.data : [];
        ownersCacheByBranch[branchId] = data;
        return data;
      })
      .catch((err) => {
        ownersPromiseByBranch[branchId] = null;
        throw err;
      });
  }
  return ownersPromiseByBranch[branchId];
}

// نادِ عليها بعد ما تضيف مالك/جهة جديدة من صفحات الإدارة عشان الدروبداون يحدّث نفسه
export function clearLookupsCache() {
  Object.keys(partiesCacheByBranch).forEach((k) => delete partiesCacheByBranch[k]);
  Object.keys(partiesPromiseByBranch).forEach((k) => delete partiesPromiseByBranch[k]);
  Object.keys(ownersCacheByBranch).forEach((k) => delete ownersCacheByBranch[k]);
  Object.keys(ownersPromiseByBranch).forEach((k) => delete ownersPromiseByBranch[k]);
}

function useAsyncList(fetcher) {
  const [state, setState] = useState({ data: [], loading: true, error: "" });

  useEffect(() => {
    let mounted = true;
    setState((s) => ({ ...s, loading: true, error: "" }));
    fetcher()
      .then((data) => {
        if (mounted) setState({ data, loading: false, error: "" });
      })
      .catch(() => {
        if (mounted)
          setState({ data: [], loading: false, error: "تعذر تحميل البيانات" });
      });
    return () => {
      mounted = false;
    };
  }, [fetcher]);

  return state;
}

// ─── Select عام (مالوش علاقة بالـ API، بس بيعرض options) ───────────────────
function BaseSelect({
  label,
  value,
  onChange,
  options,
  labelKey = "name",
  valueKey = "name",
  placeholder = "اختر...",
  loading,
  error,
}) {
  return (
    <div className="groub_fe">
      {label && <label>{label}</label>}
      <select
        value={value ?? ""}
        onChange={(e) => onChange(e.target.value)}
        disabled={loading}
        className="border w-full"
      >
        <option value="">{loading ? "جاري التحميل..." : placeholder}</option>
        {options.map((opt) => (
          <option key={opt.id ?? opt[valueKey]} value={opt[valueKey]}>
            {opt[labelKey]}
          </option>
        ))}
      </select>
      {error && (
        <p style={{ color: "#dc2626", fontSize: "12px", marginTop: "4px" }}>
          {error}
        </p>
      )}
    </div>
  );
}

// ─── دروبداون جهة (مقاول / مهندس / مشرف) مفلتر بالنوع وبفرع المستخدم ───────
// type: "المقاول" | "المهندس" | "المشرف"
export function PartySelect({ type, label, name, value, onChange, valueKey = "name" }) {
  const branchId = localStorage.getItem("branchId") || 1;
  const fetcher = useCallback(() => fetchParties(branchId), [branchId]);
  const { data, loading, error } = useAsyncList(fetcher);
  const filtered = data.filter((p) => p.type === type);

  return (
    <BaseSelect
      label={label}
      value={value}
      onChange={(v) => onChange({ target: { name, value: v } })}
      options={filtered}
      loading={loading}
      error={error}
      valueKey={valueKey}
      placeholder={`اختر ${label}`}
    />
  );
}

// ─── دروبداون مالك المشروع (من غير فلترة نوع) ──────────────────────────────
export function OwnerSelect({
  label = "مالك المشروع",
  name = "ProjectOwner",
  value,
  onChange,
  valueKey = "name",
}) {
  const branchId = localStorage.getItem("branchId") || 1;
  const fetcher = useCallback(() => fetchOwners(branchId), [branchId]);
  const { data, loading, error } = useAsyncList(fetcher);

  return (
    <BaseSelect
      label={label}
      value={value}
      onChange={(v) => onChange({ target: { name, value: v } })}
      options={data}
      loading={loading}
      error={error}
      valueKey={valueKey}
      placeholder="اختر مالك المشروع"
    />
  );
}